import React from "react"
import { Box } from "@mui/material"
import { ButtonLoadingSeeker, IconSeeker } from "@ui-seeker/core"
import { autoEuropeSeasonSetsDrawerErrors, clearAutoEuropeSeasonSetsSignals } from "Pages/AutoEuropeTool/SeasonSets/@signals"

export default function AutoEuropeSeasonSetsFooter({ onSubmit, isLoading }) {
	return <Box>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			startIcon={<IconSeeker icon="circle-left" tooltip="Cancel"/>}
			onClick={clearAutoEuropeSeasonSetsSignals}
			variant="outlined"
		>
			Cancel
		</ButtonLoadingSeeker>
		<ButtonLoadingSeeker
			sx={{ m: 1 }}
			loading={isLoading}
			startIcon={<IconSeeker icon="floppy-disk" tooltip="Save"/>}
			disabled={!Object.values(autoEuropeSeasonSetsDrawerErrors.value).every(a => a)}
			onClick={onSubmit}
		>
			Save
		</ButtonLoadingSeeker>
	</Box>
}
